// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"3e7d60ae","732":"ea6255c8","977":"9c85c1a7"}[chunkId] + ".chunk.js";
};